import { callAct, isOk } from './apiConfig';

/*
 * openingHours — the business's opening hours (שעות פעילות), server-backed + multi-tenant
 * (every act is businessID-scoped). Backed by the existing openingTimes acts.
 *
 * DB row model (businessOpeningTimes):
 *   type 1 = weekly recurring  → dayInWeek (1=Sunday … 7=Saturday), startTime, endTime
 *   type 2 = one-time OPEN      → startingDate, endingDate, startTime, endTime, description
 *   type 3 = one-time CLOSED    → startingDate, endingDate, startTime, endTime, description
 * area 0 = business-wide (not tied to a specific seating area).
 */

// All opening-time rows for the business. Returns [] on error (never throws).
export async function listHours() {
    try {
        const envelope = await callAct('openingTimesList', {});
        if (isOk(envelope) && Array.isArray(envelope.data)) return envelope.data;
        // single-row responses come back as an object — normalize to a list
        if (isOk(envelope) && envelope.data && typeof envelope.data === 'object') return [envelope.data];
    } catch (e) { /* act unavailable */ }
    return [];
}

// Add one opening-time row. `payload` carries the type-specific fields. → { ok, id }.
export async function addHour(payload) {
    try {
        const envelope = await callAct('addOpeningTimes', payload);
        return { ok: isOk(envelope), id: envelope?.data?.ID };
    } catch (e) { return { ok: false }; }
}

// Soft-delete one row by ID. → { ok }.
export async function delHour(id) {
    try {
        const envelope = await callAct('delOpeningTimes', { ID: id });
        return { ok: isOk(envelope) };
    } catch (e) { return { ok: false }; }
}

export default { listHours, addHour, delHour };
